import { BaseServiceClass } from 'base-service-class';
import httpClient, { ApiResponseWrapper } from 'http-client';
import {
    CatalogItem,
    CatalogListData,
    CreateCatalogRequest,
    GetCatalogListRequest,
    UpdateCatalogRequest,
} from './models';

// We no longer need normalizeCatalogItem and normalizeCatalogVersion as UI consumes exact models

export default class CatalogApi extends BaseServiceClass {
    /**
     * GET /api/Catalog/ListAll?skip=0&take=10
     * Request query: skip, take
     */
    static listAll(
        args: GetCatalogListRequest,
        token: string,
    ): Promise<ApiResponseWrapper<CatalogListData>> {
        return httpClient
            .get<ApiResponseWrapper<CatalogListData>>(
                `${this.BASE_URL}/api/Catalog/ListAll`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        skip: args.skip ?? 0,
                        take: args.take ?? 10,
                        filter: args.filter,
                        category: args.category,
                        status: args.status,
                    },
                },
            )
            .then((res) => {
                const data = res.data;
                return data;
            });
    }

    /**
     * GET /api/Catalog/GetById?id=...
     * Request query: id
     */
    static getById(
        id: string,
        token: string,
    ): Promise<ApiResponseWrapper<CatalogItem>> {
        return httpClient
            .get<ApiResponseWrapper<CatalogItem>>(
                `${this.BASE_URL}/api/Catalog/GetById`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id: id,
                    },
                },
            )
            .then((res) => {
                const data = res.data;
                return data;
            });
    }

    /**
     * GET /api/Catalog/GetVersionHistory?id=...
     * Request query: id
     */
    static getVersionHistory(
        id: string,
        token: string,
    ): Promise<ApiResponseWrapper<CatalogItem[]>> {
        return httpClient
            .get<ApiResponseWrapper<CatalogItem[]>>(
                `${this.BASE_URL}/api/Catalog/GetVersionHistory`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id: id,
                    },
                },
            )
            .then((res) => {
                const data = res.data;
                return data;
            });
    }

    /**
     * POST /api/Catalog/ApproveCatalog?id=...
     * Request query: id, body null
     */
    static approveCatalog(
        id: string,
        token: string,
    ): Promise<ApiResponseWrapper<null>> {
        return httpClient
            .post<ApiResponseWrapper<null>>(
                `${this.BASE_URL}/api/Catalog/ApproveCatalog`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id: id,
                    },
                },
            )
            .then((res) => res.data);
    }

    /**
     * POST /api/Catalog/Create
     * Request body: { title, description, category, teamId, version, file, status }
     */
    static createCatalog(
        data: CreateCatalogRequest,
        token: string,
    ): Promise<ApiResponseWrapper<CatalogItem>> {
        return httpClient
            .post<ApiResponseWrapper<CatalogItem>>(
                `${this.BASE_URL}/api/Catalog/Create`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then((res) => {
                const resData = res.data;
                return resData;
            });
    }

    /**
     * PUT /api/Catalog/Update
     * Request body: { id, title, description, category, teamId, version, file, status, originalFileName }
     */
    static updateCatalog(
        data: UpdateCatalogRequest,
        token: string,
    ): Promise<ApiResponseWrapper<CatalogItem>> {
        return httpClient
            .put<ApiResponseWrapper<CatalogItem>>(
                `${this.BASE_URL}/api/Catalog/Update`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then((res) => res.data);
    }

    /**
     * DELETE /api/Catalog/Delete?id=...
     * Request query: id
     */
    static deleteCatalog(
        id: string,
        token: string,
    ): Promise<ApiResponseWrapper<null>> {
        return httpClient
            .delete<ApiResponseWrapper<null>>(
                `${this.BASE_URL}/api/Catalog/Delete`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        id: id,
                    },
                },
            )
            .then((res) => res.data);
    }
}
